import ConfirmationAlertDialog from '@/components/client/modals/ConfirmationAlertDialog'

export type StartNewModalVariant = 'order' | 'kit-registration'

const START_NEW_MODAL_CONFIG: Record<
  StartNewModalVariant,
  { title: string; description: string; testIdPrefix: string }
> = {
  order: {
    title: 'Start a New Order?',
    description: 'Are you sure you want to start a new order?\nYour current progress will be lost.',
    testIdPrefix: 'start-new-order',
  },
  'kit-registration': {
    title: 'Register a New Kit?',
    description:
      'Are you sure you want to register a new kit?\nYour current progress will be lost.',
    testIdPrefix: 'start-new-kit-registration',
  },
}

type StartNewModalProps = {
  variant: StartNewModalVariant | null
  isSubmitting: boolean
  onOpenChange: (open: boolean) => void
  onCancel: () => void
  onConfirm: () => void
}

export default function StartNewModal({
  variant,
  isSubmitting,
  onOpenChange,
  onCancel,
  onConfirm,
}: Readonly<StartNewModalProps>) {
  const config = variant ? START_NEW_MODAL_CONFIG[variant] : null

  return (
    <ConfirmationAlertDialog
      open={variant !== null}
      title={config?.title ?? ''}
      description={config?.description ?? ''}
      isSubmitting={isSubmitting}
      onOpenChange={onOpenChange}
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmText="Confirm"
      cancelText="Go Back"
      confirmDanger
      testIdPrefix={config?.testIdPrefix ?? 'start-new'}
    />
  )
}
